module.exports = __webpack_public_path__ + "static/media/application-note.73a2abc0.svg";